export default "__VITE_ASSET__6cf656dd__"